module.exports = __webpack_public_path__ + "static/media/brasil.5cdc3199.jpeg";